import React from "react";
import { Sparkles } from "lucide-react";

export default function CalmBadge({ size = "sm", className = "" }) {
  const isXs = size === "xs";
  return (
    <span
      data-testid="premium-badge"
      title="HAEVEN Premium member"
      className={`inline-flex items-center gap-1 brutal-card bg-accent ${isXs ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"} font-bold uppercase tracking-wider ${className}`}
    >
      <Sparkles size={isXs ? 10 : 12} strokeWidth={3} />
      Premium
    </span>
  );
}
